import { getBootstrap } from "@/lib/bootstrap";
import type { MenuItem } from "@/types/global";

export function useMainMenu(): MenuItem[] {
  return getBootstrap().menus.main;
}
